module.exports = __webpack_public_path__ + "static/media/2040317000.ea39f456.jpg";